import React, {useState,useEffect} from "react";
import moment from 'moment'
import { Rank } from './style'
// import bwmodel from '@/config/bwmodel'
// import  {Base64 }  from 'js-base64/base64.js';
import {
  getMatchSeasonRank,
  // getMatchWeekList,
  // getMatchWeekRank,
  getMatchMyRank
} from '@/api/user-new'


import {
  getMatchWeekList
  // getMatchWeekRank
} from '@/api/combine'

const RankBox = ({activityId,showBottom=true , token, rankIndex}) => {

  const [ key, setKey ] = useState('t1')
  const [ info, setInfo ] = useState([])
  const [rankingLineList, setRankingLineList] = useState([])
  // const [showWeekList, setShowWeekList] = useState(false)
  
  const [weekList, setWeekList] = useState([]) // 周列表




  // 是否显示周空白
  
  // 是否显示季度空白

  // 赛季排行榜


  useEffect(async () => {
    const params = {
      activityId: activityId
    }
    const data = await getMatchSeasonRank(params)

    setRankingLineList(data.rankingLineList)

  }, [])

// 周列表
  useEffect(async () => {
 
    const params = {
      activityId: activityId
    }

    const res = await getMatchWeekList(params)

    const list = res.data.length > 0 ? res.data : [{}]
    setWeekList(list)
   
    // const activeTerm = data.weekLineVOList.find(item => item.isCurrent)||{};
    // setTermInfo(activeTerm)

  }, [])



  // 我的排名
  useEffect( () => {
    getMyRank()
    
  }, [token, rankIndex])

  const getMyRank = async () => {
    if(token) {}
    if(showBottom) {
      const params = {
        activityId: activityId
      }
      const info = await getMatchMyRank(params)

  
      setInfo(info)
    }
  }
  

  function goAppPage (url) {
    // app  内打开
    // if(bwmodel.app === 'storm') {
      window.location.href = url;
    // } 
    // else if (bwmodel.system === 'iPhone') {
    //   // eslint-disable-next-line no-useless-concat
    //   const  str = 'storm://app/userzone?userID=' + item.userId;

    //   let universalUrl = 'storm?baseURL=' + Base64.encode(str)

    //   let appOpenUrl = process.env.REACT_APP_appOpenUrl 
  
    //   window.location.href = appOpenUrl + universalUrl
    // }
  }

  return (
      <Rank className='rank'>
        <div className={ key === 't2'?'tab active' : 'tab'} >
          <div className={key === 't1'?'tab_item active' : 'tab_item'} onClick={()=> {setKey('t1')}}>
            {'周'}排行 
           {/* {
            weekList.length> 0? 
           
            <img
              className={showWeekList?'tab_item_img active':'tab_item_img'} 
              onClick={()=>{
                if(key === 't2') {
                  return
                }
                setShowWeekList(!showWeekList)
              }}
              src={require('@/img/activity50/arrow45.png')} alt="市值风云" 
            />
            :""
           } */}
           
          </div>
         
          
          <div 
            className={key === 't2'?'tab_item active' : 'tab_item'}  
            onClick={()=> {
  
            setKey('t2')}
          }>季排行</div>
        </div>
     
        <div className={key === 't2'?'rank_table active' : 'rank_table'}  >
          {
             key==='t1'? (
              <div> 
                 {
                  showBottom &&  <div className="title_box"> 
                  <div className="rank">我的本周排名：{
                        info.myWeekRank ? (info.myWeekRank > 200? '200+' : info.myWeekRank ):'-'}</div>
                  <div className="combineName">
                    <div>组合名称: {info.myWeekCombineName || '-'}</div>
                    <div>距离上榜的收益差距：{ info.isOnWeekBoard ? '-': info.onWeekBoardGap ? info.onWeekBoardGap + '%' : '-'}</div>
                  </div>
                </div>
                 }
               
                {
                  weekList.map((item)=> {
                    return  (
                      <div className="list_box">
                        
                       {
                        item.startTime &&  <div className="bgd">{item.name}（{moment(item.startTime).format('YYYY.MM.DD')}-{moment(item.endTime).format('YYYY.MM.DD')}）</div>
                       }<div style={{margin: '0 -17px'}}>
                          <div className="tab_rank_item_header" >
                            <div className='tab_rank_item'>
                              <div className='rank'>排名</div>
                              <div className='person'>主理人</div>
                              <div className='name' style={{width:'110px'}}>组合名称</div>
                              <div className='netValue'>周涨幅</div>
                            </div>
                          </div>
                        </div>
                       
                        {
                   item.rankList&&  item.rankList.length>0? ( item.rankList.map((item,index)=> {
                      return (
                        <div className='tab_rank_item' key={item.combineCode + 'week'}>
                          <div className={`rank ${index<3? `rank${index}`:''}` }>{index + 1}</div>
                          <div 
                            onClick={() => {
                              const url = 'storm://app/userzone?userID=' + item.userId;
                              goAppPage(url,item)
                            }
                           }
                            className= 'person'>
                            <span> {item.creator || '-'} </span>
                            {
                              item.isMyInvitee === 1 &&   <img src={require('@/img/activity50/firends.png')} alt='' />
                            }
                          
                          </div>
                          <div 
                            className='name' 
                            onClick={() => {
                              const url = 'storm://app/stock/detail?stockcode=' + item.combineCode
                              goAppPage(url,item)
                            }}
                        >{item.combineName}</div>
                          {/* <div className='changePct'>{item.changePct}%</div> */}
                          <div 
                            className={`changePct ${item.changePct>=0?'active':'green'}` }
                            onClick={() => {
                              const url = 'storm://app/stock/detail?stockcode=' + item.combineCode
                              goAppPage(url,item)
                            }}
                          > {item.changePct}%</div>
                        </div>
                      )
                    })
                   ):(
                    <div className="empty" style={{'paddingBottom':'40px'}}>
                      <img src={require('@/img/activity50/emptyData.png')} alt='' />
                    </div>
                   )
                  }
                    </div>
                    )
                  })
                }
              </div>
             ): (
                    
              <div> 
                {
                  showBottom &&   <div className="title_box"> 
                  <div className="rank">我的本季排名：{info.mySeasonRank ? (info.mySeasonRank > 200? '200+' : info.mySeasonRank ):'-'} </div>
                  <div className="combineName">
                    <div>组合名称: {info.mySeasonCombineName || '-'}</div>
                    <div>距离上榜的收益差距：{info.isOnSeasonBoard ?
                    '-'
                    :info.onSeasonBoardGap  ? info.onSeasonBoardGap + '%' : '-'} </div>
                  </div>
                </div>
                }
              
                <div className="tab_rank_item_header">
                  <div className='tab_rank_item'>
                    <div className='rank'>排名</div>
                    <div className='person'>主理人</div>
                    <div className='name' style={{width:'110px'}}>组合名称</div>
                    <div className='netValue'>季涨幅</div>
                  </div>
                </div>

              </div>
             )
          }
     
            {

            key==='t2' && (
      
              <div  className='list_box' key='t2'>
                {
                  rankingLineList.map((item,index)=> {
                    return (
                      <div className='tab_rank_item' key={item.combineCode + 'season'}>
                        <div className={`rank ${index<3? `rank${index}`:''}` }>{index + 1}</div>
                        <div    className= 'person' 
                          onClick={()=>{
                            const url = 'storm://app/userzone?userID=' + item.userId;
                            goAppPage(url,item)
                          }}
                        >
                
                            <span> {item.creator || '-'} </span>
                            {
                              item.isMyInvitee === 1 &&   <img src={require('@/img/activity50/firends.png')} alt='' />
                            }
                      
                        </div>
                        <div 
                          className='name' 
                          onClick={() => {
                            const url = 'storm://app/stock/detail?stockcode=' + item.combineCode
                            goAppPage(url,item)
                          }}
                        >{item.combineName}</div>
                        <div 
                          className={`changePct ${item.changePct>=0?'active':'green'}` }
                          onClick={() => {
                            const url = 'storm://app/stock/detail?stockcode=' + item.combineCode

                            goAppPage(url,item)
                          }}
                        > {item.changePct}%</div>
                      </div>
                    )
                  })
                }

{
                   
                rankingLineList.length === 0 ? <div className="empty">
                  <img src={require('@/img/activity50/emptyData.png')} alt='' />
                </div>:''
                }
               
                
              </div>
            )
        }
         
         </div>
         {/* <div  className={'message'} >注：以上排名为该用户所有组合最高排名</div> */}
      </Rank>

  )
}

export default RankBox;


// WEBPACK FOOTER //
// ./src/views/activity_50/components/rank.js